import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MagneticCursor from "@/components/MagneticCursor";
import Loader from "@/components/Loader";
import Hero from "@/components/Hero";
import RibbonSeries from "@/components/RibbonSeries";
import Showcase from "@/components/Showcase";
import Philosophy from "@/components/Philosophy";
import Words from "@/components/Words";
import SectionIndicator from "@/components/SectionIndicator";
import useSeo, { useJsonLd } from "@/hooks/useSeo";

export default function Home() {
  const location = useLocation();
  useSeo({
    title: "Rushit Shah — Contemporary Indian Abstract Artist | Official Site",
    description:
      "Official archive of Rushit Shah — contemporary Indian abstract painter (b. 1986, Vadodara), working between India, Singapore and Germany. Layered impasto, drip, lacquer and dyed-ground paintings.",
    keywords:
      "Rushit Shah, Rushit Shah artist, Rushit Shah abstract art, Rushit Shah paintings, contemporary abstract artist, Indian abstract painter, abstract painting, Vadodara artist, contemporary Indian art",
    image: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/bmuvwvy6_IMG_6978.jpg",
  });
  useJsonLd(
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Rushit Shah",
      alternateName: "Rushit Shah Artist",
      jobTitle: "Visual Artist",
      birthDate: "1986-09-08",
      birthPlace: { "@type": "Place", name: "Vadodara, Gujarat, India" },
      nationality: "Indian",
      url: "https://www.rushitshah.com",
      image:
        "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/bmuvwvy6_IMG_6978.jpg",
      description:
        "Indian contemporary abstract painter working between India, Singapore and Germany. Layered impasto, drip, lacquer and dyed-ground paintings.",
      knowsAbout: ["Abstract painting", "Contemporary art", "Indian art", "Impasto", "Colour theory"],
      knowsLanguage: ["en", "de", "fr", "it", "zh", "ja"],
      address: [
        { "@type": "PostalAddress", addressCountry: "IN", addressLocality: "Vadodara" },
        { "@type": "PostalAddress", addressCountry: "SG", addressLocality: "Singapore" },
        { "@type": "PostalAddress", addressCountry: "DE" },
      ],
      sameAs: [
        "https://instagram.com/rushitshah08",
        "https://www.artworkarchive.com/profile/rushitshah",
      ],
      email: "mailto:rs@rushitshah.com",
    },
    "ld-person"
  );

  useJsonLd(
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Rushit Shah — Archive",
      url: "https://www.rushitshah.com",
      inLanguage: ["en", "de", "fr", "it", "zh", "ja"],
      publisher: { "@type": "Person", name: "Rushit Shah" },
    },
    "ld-website"
  );

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el && window.__lenis) window.__lenis.scrollTo(el);
        else if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 600);
    }
  }, [location]);

  return (
    <div className="relative" data-testid="landing-root">
      <Loader />
      <SectionIndicator />
      <main>
        <Hero />
        <RibbonSeries />
        <Showcase />
        <Philosophy />
        <Words />
      </main>
    </div>
  );
}
